import { useState } from "react";
import { AnimatePresence } from "motion/react";
import { motion } from "motion/react";
import { ChevronDown, ChevronUp } from "lucide-react";

const FONT = "'Noto Sans SC', 'Inter', sans-serif";

export default function FAQItem({
  q,
  a,
  index,
}: {
  q: string;
  a: string;
  index: number;
}) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`border-b border-white/10 last:border-0`}>
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-4 py-4 text-left cursor-pointer"
        style={{ fontFamily: FONT }}
      >
        <span className="text-[15px] text-white" style={{ fontWeight: 600 }}>
          Q：{q}
        </span>
        <span className="flex-shrink-0 w-7 h-7 rounded-full bg-white/10 flex items-center justify-center text-white">
          {open ? (
            <ChevronUp className="w-4 h-4" />
          ) : (
            <ChevronDown className="w-4 h-4" />
          )}
        </span>
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.22 }}
            className="overflow-hidden"
          >
            <p
              className="pb-4 text-[14px] text-white/75 leading-relaxed"
              style={{ fontFamily: FONT, fontWeight: 400 }}
            >
              A：{a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
